import { CHECKOUT_API_KEY } from '../../constants';
import { isIOSDevice } from '../../utils/deviceUtils';
import { baseRequest, baseCardPaymentMethod } from './constants';

const GOOGLE_PAY_SDK_ID = 'google-pay-sdk';
const GOOGLE_PAY_SDK_URL = 'https://pay.google.com/gp/p/js/pay.js';

export const GOOGLE_PAY_ENVIRONMENT = CHECKOUT_API_KEY.includes('_sbox_') ? 'TEST' : 'PRODUCTION';

let sdkPromise = null;

// Single shared load: callers may mount before the script tag exists
export const loadGooglePaySdk = () => {
    if (window.google && window.google.payments) {
        return Promise.resolve();
    }

    if (!sdkPromise) {
        sdkPromise = new Promise((resolve, reject) => {
            const script =
                document.getElementById(GOOGLE_PAY_SDK_ID) || document.createElement('script');
            script.addEventListener('load', () => resolve());
            script.addEventListener('error', () => {
                sdkPromise = null;
                reject(new Error('Google Pay SDK failed to load'));
            });

            if (!script.id) {
                script.id = GOOGLE_PAY_SDK_ID;
                script.src = GOOGLE_PAY_SDK_URL;
                script.async = true;
                document.head.appendChild(script);
            }
        });
    }

    return sdkPromise;
};

const createGooglePayClient = () =>
    new window.google.payments.api.PaymentsClient({ environment: GOOGLE_PAY_ENVIRONMENT });

// Same card methods as the payment request; paymentMethodPresent is not used to hide (Google advice)
export const checkGooglePayReady = () => {
    // Popup flow never completes on iOS (Safari or app webview)
    if (isIOSDevice()) {
        return Promise.resolve(false);
    }

    return loadGooglePaySdk()
        .then(() =>
            createGooglePayClient().isReadyToPay({
                ...baseRequest,
                allowedPaymentMethods: [baseCardPaymentMethod]
            })
        )
        .then(response => Boolean(response && response.result))
        .catch(error => {
            console.error('Error while verifying if Google Pay is available :', error);
            return false;
        });
};



// WEBPACK FOOTER //
// ./src/services/googlepay/utils.js